import { Spinner } from '@iwoca/orion';
import { Outlet } from 'react-router';

import { NewRoutesWrapperArrayType, NewRoutesWrapperType } from './utils';

const DemoEntrypoint = ({ isStart }: { isStart: boolean }) => {
  if (isStart) {
    localStorage.setItem('demoModeEnabled', 'true');
    // we need to navigate outside of react-router to reset state
    window.location.href = '/pay/dashboard/?state_key=demo_system';
  } else {
    localStorage.removeItem('demoModeEnabled');
    // this will get redirected off to eden etc
    window.location.href = '/pay/dashboard/';
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner />
    </div>
  );
};

const ENTRYPOINTS = [
  {
    path: 'demo/start',
    element: <DemoEntrypoint isStart={true} />,
  },
  {
    path: 'demo/end',
    element: <DemoEntrypoint isStart={false} />,
  },
] as const satisfies NewRoutesWrapperType['paths'];

const DEMO_ENTRYPOINTS = {
  wrapper: <Outlet />,
  paths: ENTRYPOINTS,
} as const satisfies NewRoutesWrapperType;

export const DEMO_ROUTES = [
  DEMO_ENTRYPOINTS,
] as const satisfies NewRoutesWrapperArrayType;
